export const environment = {
  production: true,
  envName: 'apprex',
  apiUrl: 'https://apprex.gast.de/gast-service-auth/api/public/',
};
